import { makeFirstLetterUppercase } from './util';

export type DataTestType =
  | 'banner'
  | 'header'
  | 'card'
  | 'carousel'
  | 'carouselAutomatic'
  | 'carouselManual'
  | 'cell'
  | 'checkbox'
  | 'chip'
  | 'button'
  | 'cart'
  | 'dialog'
  | 'dropdown'
  | 'form'
  | 'heroSlider'
  | 'imagesGallery'
  | 'image'
  | 'input'
  | 'item'
  | 'icon'
  | 'list'
  | 'loader'
  | 'mediaWrapper'
  | 'modal'
  | 'modelStory'
  | 'priceInformation'
  | 'productBreadcrumbs'
  | 'productCard'
  | 'productDetail'
  | 'productDetailSection'
  | 'productRow'
  | 'radio'
  | 'row'
  | 'scrollToTop'
  | 'section'
  | 'select'
  | 'servicePerks'
  | 'services'
  | 'slider'
  | 'stepper'
  | 'stores'
  | 'strapSizes'
  | 'switch'
  | 'table'
  | 'text'
  | 'warrantyExplore'
  | 'scanner'
  | 'warrantyDetails'
  | 'collectionWrapper'
  | 'footer'
  | 'DoubleCardWide'
  | 'DoubleCard'
  | 'contentCollection'
  | 'ThreeColumnTeaser'
  | 'col'
  | 'ThreeColumnScroll'
  | 'CollectionGroup'
  | 'ScrollableRow'
  | 'IdentifyWatch'
  | 'Moonphase'
  | 'grid';

type DataTestName = string;

export const DATA_TEST_SELECTOR = 'data-testid';

export type DataTestId = Record<typeof DATA_TEST_SELECTOR, string>;

/**
 * @deprecated
 * This function has been deprecated and is here only for backwards-compatibility. For new development please manually add the data-test-id attribute to the element.
 */
export const generateDataTestId = (
  type: DataTestType,
  name?: DataTestName,
): DataTestId => {
  const splitNameBySpace = name?.split(' ');

  const nameFirstLettersUppercase =
    splitNameBySpace?.map(makeFirstLetterUppercase).join('') ?? '';

  return { [DATA_TEST_SELECTOR]: `${type}${nameFirstLettersUppercase}` };
};

export const mockModalRoot = () => {
  const modalRoot = document.createElement('div');
  modalRoot.setAttribute('id', 'modal-root');
  document.body.appendChild(modalRoot);
};

export const generateCmsRichText = <T>(text: string) =>
  ({
    json: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: text,
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
  }) as T;
